export default {
  meta: {
    title: '项目编辑'
  }
};
